exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard{width:100%;padding-bottom:20px;padding-top:20px;display:flex;justify-content:center}.dashboard .row{max-width:1024px;width:100%;margin:0}.dashboard .row .col-md-4{margin:0;padding:0}.dashboard .item-container{background:#00adff;padding-top:100%;margin:10px;position:relative;margin-bottom:0;margin-top:20px}.dashboard .item-container.blue{background-color:#bbd9ff}.dashboard .item-container .item-content{width:100%;height:100%;box-sizing:border-box;top:0;position:absolute;display:flex;align-items:center;justify-content:center;flex-direction:column}.dashboard .item-container .item-content .icon{width:calc(100% - 60px);height:calc(100% - 60px);display:flex;align-items:center;justify-content:center}.dashboard .item-container .item-content .icon img{width:100%}.dashboard .item-container .item-content h3{color:#fff;width:100%;text-align:center;line-height:60px;border-top:2px solid #fff;margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/DashboardPage/style.scss
// module id = 2750
// module chunks = 0